import { defa }      from 'defa-object';
import UserContainer from 'scripts/defa/users/view-user-container';
import Service       from 'scripts/poppet/service';

/**
 * defa.services.PageVisibilityHandler
 * A service for handling Page Visibility API.
 * @version 1.1.9
 */


const channelLayout = Bb.Radio.channel( 'layout' );
const channelUser   = Bb.Radio.channel( 'user' );

const PageVisibilityHandler = Service.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	deeplinkFragments: [
		'accounts/new',
		'accounts/forgot',
		'accounts/login',
		'accounts/thank-you',
		'/install',
	],
	
	blacklistFragments: [
		'/installed',
	],
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * @constructor
	 */
	initialize: function () {
		
		this.listenTo( channelUser, 'user:change:logged', this.onUserChangeLogged );
	},
	
	/**
	 * Triggers when a user changes it's login state.
	 * @void
	 */
	onUserChangeLogged: function () {
		
		// activate visibility api for everyone but technical support.
		if ( !channelUser.request( 'model' ).hasRoles( [ 'TECHNICAL_SUPPORT', ] ) ) {
			this.listenTo( document, 'show', this.onDocumentShow );
		}
	},
	
	/**
	 * Triggers when a document triggers show.
	 * @void
	 */
	onDocumentShow: function () {
		
		// save the current application state
		this._saveCurrentState();
		
		// listen for a fresh unit
		this.listenToOnce( channelUser, 'user:fresh', this.onUserFresh );
		
		// inform the channel that the user is stale.
		channelUser.trigger( 'user:stale' );
		
	},
	
	/**
	 * Triggers when the channelUser triggers done.
	 * @void
	 */
	onUserFresh: function () {
		
		// default state is no refresh:
		let doReload = false;
		
		// if the fresh user login state doesn't match stale user login state, do a full page refresh.
		if ( channelUser.request( 'logged:in' ) !== this.loggedIn ) {
			doReload = true;
		}
		
		// the url must not be blacklisted, and it needs to have a redirIndex
		if ( !this.blacklisted && -1 !== this.redirIndex ) {
			
			// if this is a login related view, and the user is logged in, refresh.
			if ( -1 !== this.deeplinkFragments[ this.redirIndex ].indexOf( 'accounts' ) && channelUser.request( 'logged:in' ) ) {
				doReload = true;
			}
			
			
			// !TODO: this is really convoluted, come up with a better way to identify if a certain view is attached to
			// the DOM than the try-catch. if this is an installation related view, prepare for refresh with exceptions
			if ( ( -1 !== this.deeplinkFragments[ this.redirIndex ].indexOf( '/install' ) ) ) {
				
				// install state view within claim-layout
				let installView = false;
				
				// !TODO: Should we check that the second nested is a claimFlow?
				
				// !TODO: Can we make this work with underscore lookup?
				
				// !TODO: Build lookup into RegionManager's currentView to create a .deeperView() / instance of? . this
				// could be a layouthandler function deepviewInstanceOf ( loop through all childViews and their
				// childViews, and check if they are an instance of sth
				
				// With a new event channel, the installView can set it's own flag as a type of poppet that needs
				// attention.
				
				// set installView to the third deepest view within root.
				
				try {
					installView = channelLayout.request( 'root' ).getRegion( 'main' ).currentView.getRegion( 'container' ).currentView.getRegion( 'container' ).currentView.getRegion( 'container' ).currentView;
					
					// ignore failures, installView then stays falsy on error..
				} catch ( error ) {
					// nothing
					
					// check for exceptions to do or not to do reload:
				} finally {
					
					// no-reload states:
					if ( !installView
						 || ( installView instanceof defa.views.settingsAutomotiveForm )
						 || ( installView instanceof UserContainer && channelUser.request( 'logged:out' ) ) ) {
						// do nothing
						
						// do-reload states:
					} else {
						doReload = true;
					}
				}
			}
		}
		
		// execute the visibility api based reload
		if ( doReload ) {
			window.location.reload( true );
		}
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Saves all current application information important for visibility and reloading.
	 * @void
	 */
	_saveCurrentState: function () {
		
		// a string with the current uri.
		let deeplink = Bb.history.fragment;
		
		// an integer for which index of this.deeplinkFragments matches the deeplink.
		this.redirIndex = _.findIndex( this.deeplinkFragments, function ( fragment ) {
			if ( -1 !== deeplink.indexOf( fragment ) ) {
				return true;
			}
		} );
			
		// a boolean, true if this current deeplink matches anything from this.blacklistFragments
		this.blacklisted = ( -1 !== _.findIndex( this.blacklistFragments, function ( blacklist ) {
			if ( -1 !== deeplink.indexOf( blacklist ) ) {
				return true;
			}
		} ) );
		
		// a boolean saving the login state of the existing (stale) user model
		this.loggedIn = channelUser.request( 'logged:in' );
		
	},
	
} );

export default PageVisibilityHandler;